export enum TranslationExportOptions {
    None = 0,
    EmptyTargets = 1
}
